import React from "react"
import { Link, useParams } from "react-router-dom"
import { ActivityOwner } from "@/types/activities"
import i18n from "@/i18n"
import { staffMemberPath } from "@/shared/urls"

const OwnerLabel = ({ owner }: { owner: ActivityOwner }) => {
  const { slug } = useParams<{ slug: string }>()
  const createdByCustomer = owner?.type === "customer"
  const translationKey = `app.activities.reservation.owner_label.${createdByCustomer ? "customer" : "employee"}`

  if (createdByCustomer || !owner) {
    return (
      <span data-testid="panel-activity-owner-label" className="font-semibold text-gray-900">
        {i18n.t(translationKey)}
      </span>
    )
  }

  const ownerName = owner.firstName || owner.lastName ? `${owner.firstName} ${owner.lastName}` : owner.email
  const ownerLink =
    slug && owner.id ? (
      <Link
        data-testid="panel-activity-owner-link"
        to={staffMemberPath(slug, owner.id)}
        className="font-semibold text-gray-900 hover:underline"
      >
        {ownerName}
      </Link>
    ) : (
      <span data-testid="panel-activity-owner-label" className="font-semibold text-gray-900">
        {ownerName}
      </span>
    )

  return i18n.react(translationKey, { name: ownerLink })
}

export default OwnerLabel
